import { toast } from '@/view/components/ui/use-toast'
import { LessonFormValues } from '@/view/pages/Conteudos/hooks/useClssForm'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { trainingService } from '../services/trainingService'

export const parseLessonFormValuesToFormData = (values: LessonFormValues) => {
  return { ...values, name: values?.title }
}

export const useLessonMutations = () => {
  const queryClient = useQueryClient()

  const createLessonMutation = useMutation({
    mutationFn: ({
      trainingId,
      lesson,
    }: {
      trainingId: string
      lesson: LessonFormValues
    }) =>
      trainingService.addLessonToTraining(
        trainingId,
        parseLessonFormValuesToFormData(lesson),
      ),
    onSuccess: () => {
      toast({
        title: 'Aula criada com sucesso',
        description: 'Aula criada com sucesso',
        variant: 'default',
      })
      queryClient.invalidateQueries({ queryKey: ['training'] })
    },
    onError: () => {
      toast({
        title: 'Erro ao criar aula',
        description: 'Por favor, tente novamente mais tarde',
        variant: 'destructive',
      })
    },
  })

  const updateLessonMutation = useMutation({
    mutationFn: ({
      lessonId,
      lesson,
    }: {
      lessonId: string
      lesson: LessonFormValues
    }) =>
      trainingService.updateLesson(
        lessonId,
        parseLessonFormValuesToFormData(lesson),
      ),
    onSuccess: (_, { lessonId }) => {
      toast({
        title: 'Aula atualizada com sucesso',
        description: 'Aula atualizada com sucesso',
        variant: 'default',
      })
      queryClient.invalidateQueries({
        queryKey: ['training'],
      })
      queryClient.invalidateQueries({
        queryKey: ['lesson', lessonId],
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao atualizar aula',
        description: 'Por favor, tente novamente mais tarde',
        variant: 'destructive',
      })
    },
  })

  const deleteAttachmentMutation = useMutation({
    mutationFn: trainingService.deleteAttachment,
    onSuccess: () => {
      toast({
        title: 'Arquivo deletado com sucesso',
        description: 'Arquivo deletado com sucesso',
        variant: 'default',
      })
      queryClient.invalidateQueries({ queryKey: ['training'] })
    },
    onError: () => {
      toast({
        title: 'Erro ao deletar arquivo',
        description: 'Por favor, tente novamente mais tarde',
        variant: 'destructive',
      })
    },
  })

  const deleteLessonMutation = useMutation({
    mutationFn: trainingService.deleteLesson,
    onSuccess: () => {
      toast({
        title: 'Aula deletada com sucesso',
        variant: 'default',
      })
      queryClient.invalidateQueries({ queryKey: ['training'] })
    },
    onError: () => {
      toast({
        title: 'Erro ao deletar aula',
        variant: 'destructive',
      })
    },
  })

  return {
    createLessonMutation,
    updateLessonMutation,
    deleteAttachmentMutation,
    deleteLessonMutation,
  }
}
